import { render, staticRenderFns } from "./branchAccounts.vue?vue&type=template&id=aedaa83e&"
import script from "./branchAccounts.vue?vue&type=script&lang=js&"
export * from "./branchAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports